import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { FilterTitleBox } from "../../components/layouts/OneViewBox";
import { findObjectKeyByValue, titleCase } from "../../utils/helper";
import { formatNumberCustomPattern } from "../../utils/helper";
import { current } from "@reduxjs/toolkit";
import { Info } from "@mui/icons-material";

export const STATUS_COLOR_TYPE = (currentstatus) => {
  switch (currentstatus) {
    case true:
      return "rgba(26, 68, 173,0.08)";
    default:
      return "white";
  }
};
const ButtonComponentsUi = ({
  count,
  onSubmit,
  Title,
  ButtonGroup,
  colorType,
  STATUSWiseData,
  CountButtonGroup,
  width = "18vw",
  isSmallText,
  isSerialNumber,
  noBoxShadow,
  cursor,
}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  return (
    <>
      <Card
        variant="outlined"
        onClick={onSubmit}
        sx={{
          backgroundColor: STATUS_COLOR_TYPE(colorType),
          width: width,
          borderRadius: "8px",
          cursor: cursor || "pointer",
          // boxShadow: "0px 2px 5px rgba(158, 16, 16, 0.12)",
          height: "13vh",
          border: colorType
            ? "1px solid rgb(102, 89, 200)"
            : "1px solid #d7bebec3",
        }}
      >
        <Box
          sx={{
            width: "40%",
            height: 3,
            backgroundColor: colorType && "rgb(61, 52, 143)",
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            mx: "auto",
          }}
        />

        <Box sx={{ display: "flex" }}>
          {noBoxShadow && (
            <Box height={"12vh"} display={"flex"} alignItems={"center"}>
              {" "}
              <Box
                sx={{
                  width: "4px",
                  height: "13vh",
                  borderRadius: "10px",
                  background: "#0E2548",
                }}
              />
            </Box>
          )}
          <Box
            sx={{
              height: "12vh",
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              variant={isSmallScreen ? "body2" : "body1"}
              sx={(theme) => ({
                fontWeight: isSmallText ? 500 : 700,
                color: "rgb(102, 89, 200)",
                textTransform: "uppercase",
                textAlign: "center",
              })}
            >
              {Title}
            </Typography>

            <Typography
              variant={isSmallScreen ? "h4" : "h4"}
              sx={(theme) => ({
                fontWeight: 400,
                color: "rgb(102, 89, 200)",
                textAlign: "center",
              })}
            >
              {formatNumberCustomPattern(count)}
            </Typography>
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default ButtonComponentsUi;
